import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import PropTypes from 'prop-types';
import Container from './styles';
import {MiddleButton} from './styles'

const loginLink = `https://discord.com/api/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_URL}/login&response_type=code&scope=guilds%20email%20identify`;
const perchoirLink = `https://discord.gg/perchoir`;
const Login = ({ validation, isConnected }) => {

  return (
    <Container>

      {validation.hasJoinedServer && <Redirect to='/'/>}

      {!isConnected && 
        <Container>
          <h3>Connectez-vous à l'aide de Discord pour accéder à cette fonctionnalité</h3>
          <MiddleButton href={loginLink}>
            Se connecter avec Discord
          </MiddleButton>
        </Container>
      }

      {isConnected && !validation.hasJoinedServer &&
        <Container>
          <h3>Rejoignez le Perchoir pour avoir aux fonctionnalités du site</h3>
          <MiddleButton href={perchoirLink}>
            Rejoindre le Perchoir
          </MiddleButton>
        </Container>
      }

      {/*JSON.stringify({...validation, loading})*/}
    </Container>
  );
};

Login.propTypes = {
  isConnected: PropTypes.bool.isRequired,
  validation: PropTypes.shape({
    hasJoinedServer: PropTypes.bool.isRequired,
    hasValidatedRules: PropTypes.bool.isRequired,
    hasStayedLongEnough: PropTypes.bool.isRequired,
    isBlacklisted: PropTypes.bool.isRequired,
    disallowedVillagers: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  logout: PropTypes.func.isRequired,
  validate: PropTypes.func.isRequired,
};

export default Login;
